import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify';
import Get from '../../api/Get'
import Post from '../../api/Post'
import { LANGUAGE_ALL, LANGUAGE_UPDATE } from "../../api/Routes";
import { LANGUAGE_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import LanguageList from "./language/LanguageList";
import AddLanguage from "./language/AddLanguage";
import Filtro from '../../components/catalogos/Filtro';
import LoadingList from "../../loader/LoadingList";

import '../../styles/catalogos/catalogos.css'
import { toBool } from '../../utils/toBool';
import Put from '../../api/Put';
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function LanguageIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    useEffect(() => cargarIdiomas(), [])

    const cargarIdiomas = () => {
        setLoading(true)

        Get({url: LANGUAGE_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const agregarIdioma = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: LANGUAGE_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})            
            setLoading(false)  
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)   
        })
    }

    const editarIdioma = (values) =>{
        //console.log(values)
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        } 
        //console.log(values)
        Put({url: LANGUAGE_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //console.log(response)  
        })                
        .catch((error) => {
            setLoading(false)      
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })        
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            <Filtro catName ='Idiomas'/>
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddLanguage agregarIdioma={agregarIdioma} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <LanguageList items={items} 
                        editarIdioma={editarIdioma}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default LanguageIndex